import { pointPleasantConfig } from "./data";
import CityPageTemplate from "@/pages/city-template/CityPageTemplate";

export default function PointPleasantPage() {
  return <CityPageTemplate config={pointPleasantConfig} />;
}